"use client";

import { useState } from "react";
import { Check, Copy } from "lucide-react";

/**
 * Bloques de código de la documentación: fondo oscuro en ambos temas (es lo
 * que se espera de una terminal) y un botón para copiar. Con varias variantes
 * (curl / JavaScript / Python) se muestran como pestañas.
 */

function Copiar({ texto }: { texto: string }) {
  const [copiado, setCopiado] = useState(false);
  return (
    <button
      type="button"
      onClick={() => {
        navigator.clipboard.writeText(texto).catch(() => {});
        setCopiado(true);
        setTimeout(() => setCopiado(false), 1500);
      }}
      className="inline-flex items-center gap-1 rounded-md px-2 py-1 text-[11px] font-medium text-slate-400 transition-colors hover:bg-white/10 hover:text-slate-100"
      aria-label="Copiar código"
    >
      {copiado ? <Check className="h-3.5 w-3.5 text-emerald-400" /> : <Copy className="h-3.5 w-3.5" />}
      {copiado ? "Copiado" : "Copiar"}
    </button>
  );
}

export function BloqueCodigo({ codigo, titulo }: { codigo: string; titulo?: string }) {
  return (
    <div className="overflow-hidden rounded-xl border border-slate-800 bg-[#0d1321]">
      <div className="flex items-center justify-between border-b border-slate-800 px-3 py-1.5">
        <span className="font-mono text-[11px] text-slate-400">{titulo ?? ""}</span>
        <Copiar texto={codigo} />
      </div>
      <pre className="overflow-x-auto px-4 py-3 font-mono text-[12.5px] leading-relaxed text-slate-100"><code>{codigo}</code></pre>
    </div>
  );
}

export function PestanasCodigo({ ejemplos }: { ejemplos: { etiqueta: string; codigo: string }[] }) {
  const [activa, setActiva] = useState(0);
  const actual = ejemplos[activa] ?? ejemplos[0];
  return (
    <div className="overflow-hidden rounded-xl border border-slate-800 bg-[#0d1321]">
      <div className="flex items-center justify-between border-b border-slate-800 px-2 py-1">
        <div className="flex gap-0.5" role="tablist">
          {ejemplos.map((e, i) => (
            <button
              key={e.etiqueta}
              type="button"
              role="tab"
              aria-selected={i === activa}
              onClick={() => setActiva(i)}
              className={`rounded-md px-2.5 py-1 text-[11.5px] font-medium transition-colors ${
                i === activa ? "bg-white/10 text-slate-100" : "text-slate-400 hover:text-slate-200"
              }`}
            >
              {e.etiqueta}
            </button>
          ))}
        </div>
        <Copiar texto={actual.codigo} />
      </div>
      <pre className="overflow-x-auto px-4 py-3 font-mono text-[12.5px] leading-relaxed text-slate-100"><code>{actual.codigo}</code></pre>
    </div>
  );
}
